import React from 'react';
import LongText from '../Elements/LongText';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';

export default class SurveyTransferAnswerOptionMappingItem {
  constructor(item) {
    if (item === undefined) {
      this.SurveyTransferAnswerOptionMappingId = '';
      this.SurveyTransferQuestionMappingId = '';
      this.TargetTpAnswerOptionId = '';
      this.SourceTpAnswerOptionId = '';
      this.ParentMappingIsActive = '';
      this.TargetTpAnswerOptionDisplayOrder = '';
      this.TargetOptionValue = '';
      this.SourceOptionValue = '';
      this.TargetTpAnswerOptionText = '';
      this.SourceTpAnswerOptionText = '';
    } else {
      this.initialize(item);
    }
  }

  initialize(item) {
    this.SurveyTransferAnswerOptionMappingId = item.surveyTransferAnswerOptionMappingId;
    this.SurveyTransferQuestionMappingId = item.surveyTransferQuestionMappingId;
    this.TargetTpAnswerOptionId = item.targetTpAnswerOptionId;
    this.SourceTpAnswerOptionId = item.sourceTpAnswerOptionId;
    this.ParentMappingIsActive = item.parentMappingIsActive;
    this.TargetTpAnswerOptionDisplayOrder = item.targetTpAnswerOptionDisplayOrder;
    this.TargetOptionValue = item.targetOptionValue;
    this.SourceOptionValue = item.sourceOptionValue;
    this.TargetTpAnswerOptionText = item.targetTpAnswerOptionText;
    this.SourceTpAnswerOptionText = item.sourceTpAnswerOptionText;
  }

  static NameOfTheIdField() {
    return 'SurveyTransferAnswerOptionMappingId';
  }

  static nameOfTheItemDetailList() {
    return 'Answer Option Rule';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static DateOnlyFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        {
          name: 'SurveyTransferAnswerOptionMappingId',
          label: 'Answer Option Mapping Id',
          width: TabListTableCellWidthEnum.Full,
        },
        { name: 'TargetTpAnswerOptionId', label: 'Target Answer Option Id' },
        { name: 'TargetTpAnswerOptionDisplayOrder', label: 'Target Display Order' },
        { name: 'TargetTpAnswerOptionText', label: 'Target Answer', width: TabListTableCellWidthEnum.Full },
        { name: 'SourceTpAnswerOptionId', label: 'Source Answer Option Id' },
        { name: 'SourceTpAnswerOptionText', label: 'Source Answer', width: TabListTableCellWidthEnum.Full },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Target Order',
        orderById: 'TargetTpAnswerOptionDisplayOrder',
        data: 'TargetTpAnswerOptionDisplayOrder',
        className: 'text-center',
        minWidth: 20,
      },
      {
        label: 'Target Answer',
        orderById: 'TargetTpAnswerOptionText',
        data: (item) => (
          <LongText
            text={item.TargetTpAnswerOptionText}
            maxLength={50}
          />
        ),
      },
      {
        label: 'Target 3rd Party Id',
        orderById: 'TargetOptionValue',
        data: 'TargetOptionValue',
        className: 'text-center',
        minWidth: 20,
      },
      {
        label: 'Source Answer',
        orderById: 'SourceTpAnswerOptionText',
        data: (item) => (
          <LongText
            text={item.SourceTpAnswerOptionText}
            maxLength={50}
          />
        ),
      },
      {
        label: 'Source 3rd Party Id',
        orderById: 'SourceOptionValue',
        data: 'SourceOptionValue',
        className: 'text-center',
        minWidth: 20,
      },
      {
        label: 'Actions',
        orderById: '',
        type: FieldTypesEnum.ActionButton,
        data: SurveyTransferAnswerOptionMappingItem.getActionsContent,
        minWidth: 50,
      },
      // Keep the Id (eye) column last and right-aligned so its eye sits flush at the far-right
      // edge — clear of the action menu, which floats ~44px in from the right edge on row hover.
      {
        label: 'Id',
        orderById: 'SurveyTransferAnswerOptionMappingId',
        minWidth: 20,
        className: 'text-right pr-2',
        data: (item) => (
          <LongText
            text={item.SurveyTransferAnswerOptionMappingId}
            maxLength={0}
          />
        ),
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            // Editing is only allowed while the parent mapping is inactive (enforced in the micro too).
            disabled: item.ParentMappingIsActive === true,
            tooltipText:
              item.ParentMappingIsActive === true
                ? 'Deactivate the survey transfer mapping to edit its rules'
                : 'Edit this answer option rule',
            onClick: () =>
              SurveyTransferAnswerOptionMappingItem.editFunction(item.SurveyTransferAnswerOptionMappingId, item),
          },
        ]}
      />
    );
  }

  // Wired by the hosting page (SurveyTransferAnswerOptionRulesDetails) to open the edit panel.
  static editFunction = (id, item) => {
    alert('Edit function is not wired up.');
  };
}
